import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';
import Sort from '@features/filter/Common/Sort';

const SampleListTopHeader = ({ toggleFilter }) => {
	const filterFields = useSelector((store) => store.filterFieldStore);
	const sampleStore = useSelector((store) => store.sampleStore);
	const [, setSelectedTab] = useState('');

	useEffect(() => {
		let activeTab = filterFields?.status || [];
		let currentTabOfGlobal = activeTab.find((item) => item.type === 'SELECT');
		setSelectedTab(currentTabOfGlobal?.key);
	}, [filterFields]);

	return (
		<>
			<div className="filter-container-top">
				<div className="filters">
					<div className="filter-toggle" onClick={() => toggleFilter()}>
						<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
						<span>Filter</span>
					</div>
					{/* <span className="items-count semibold-14 gray_dark_02 mr-2">
						{totalElements > 0 ? totalElements : 0} Supplier
					</span> */}

					<div className="samples-summary">
						{sampleStore?.countResponse && (
							<ul className="common-list-component">
								<li>
									<span className="semibold-14">
										{sampleStore.countResponse.noOfSampleRequest}
									</span>{' '}
									Request
								</li>
								<li>
									<span className="semibold-14">
										{sampleStore.countResponse.noOfDesign}
									</span>{' '}
									Design
								</li>
								<li>
									<span className="semibold-14">{sampleStore.countResponse.quantity}</span>{' '}
									Pcs
								</li>
								<li>
									<span className="semibold-14">
										{sampleStore.countResponse.noOfDeliveredDesign}
									</span>{' '}
									Design delivered
								</li>
							</ul>
						)}
					</div>

					<Chip />
				</div>
				<div className={`filter-actions sample-list-filter-actions`}>
					<Search placeholder="Design name & number" identifier="search" />
					<div className="transparent-sort">
						<Sort title={'SAMPLE_LIST'} removedLastModified={true} />
					</div>
				</div>
			</div>
		</>
	);
};

export default SampleListTopHeader;
